import React from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { translate } from '../../../../../utils/util';
import HomeDefault from '../../../../../components/HomeDefaultComponent';
import { ENUMS } from '../../../../../utils/constants';

const Home = () => {
    const menu = () => {
        let menuItems = [];
        menuItems = [...menuItems, { route: { pathname: 'registration/home', state: { registrationType: ENUMS.eMappingRegistrationType.Class.value, showDescription: false, title: 'Classe', icon: 'mdi mdi-clipboard-check-outline' } }, icon: 'mdi mdi-clipboard-check-outline', text: 'Classe' }];
        menuItems = [...menuItems, { route: { pathname: 'registration/home', state: { registrationType: ENUMS.eMappingRegistrationType.Line.value, showDescription: false, title: 'Linha', icon: 'mdi mdi-progress-upload' } }, icon: 'mdi mdi-progress-upload', text: 'Linha' }];
        menuItems = [...menuItems, { route: { pathname: 'registration/home', state: { registrationType: ENUMS.eMappingRegistrationType.Parts.value, showDescription: true, title: 'Trecho', icon: 'mdi mdi-truck-delivery-outline' } }, icon: 'mdi mdi-truck-delivery-outline', text: 'Trecho' }];
        menuItems = [...menuItems, { route: { pathname: 'registration/partnumberusemodel/home', state: { registrationType: ENUMS.eMappingRegistrationType.Gravitational.value, showDescription: true, title: 'Desenho x Uso e Modelo', icon: 'mdi mdi-comment-question-outline' } }, icon: 'mdi mdi-comment-question-outline', text: 'Desenho x Uso e Modelo' }];
        menuItems = [...menuItems, { route: { pathname: 'registration/home', state: { registrationType: ENUMS.eMappingRegistrationType.Gravitational.value, showDescription: true, title: 'Gravitacional', icon: 'mdi mdi-clipboard-list-outline' } }, icon: 'mdi mdi-clipboard-list-outline', text: 'Gravitacional' }];
        return menuItems;
    };

    const title = { icon: "mdi mdi-clipboard-check-outline", label: translate('mapping:title', 'line-picking') };

    const subtitles = () => {
        let subtitlesItems = [];
        subtitlesItems = [...subtitlesItems, { icon: "mdi mdi-domain", label: translate('deemsqp:menu.registrations') }];
        return subtitlesItems;
    }

    return (
        <HomeDefault menu={menu()} title={title} subtitles={subtitles()} />
    );
};

export default withRouter(withTranslation()(Home));
